"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("el-row", [_c("el-form", {
    staticStyle: {
      "padding-top": "20px",
      "padding-left": "20px"
    },
    attrs: {
      inline: true,
      model: _vm.formInline
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "搜索"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: ""
    },
    on: {
      blur: _vm.handleFilter
    },
    model: {
      value: _vm.formInline.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.formInline, "keyword", $$v);
      },
      expression: "formInline.keyword"
    }
  })], 1), _vm._v(" "), _c("el-form-item", [_c("el-button", {
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      icon: "el-icon-search",
      size: "small"
    },
    on: {
      click: _vm.handleFilter
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1), _vm._v(" "), _c("el-row", {
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    staticStyle: {
      padding: "0 20px"
    },
    attrs: {
      md: 24
    }
  }, [_c("RestTable", {
    ref: "target",
    attrs: {
      model: "/Shop/",
      keyword: _vm.formInline.keyword
    }
  }, [_c("el-table-column", {
    attrs: {
      type: "index",
      label: "序号",
      width: "60"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "company_name",
      label: "公司名称"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "scc",
      label: "统一社会信用代码"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "address",
      label: "公司地址"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "mobile",
      label: "客服电话"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "product_name",
      label: "商城名"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      label: "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-switch", {
          attrs: {
            "active-text": "开启",
            "inactive-text": "关闭",
            disabled: !_vm.isAdmin
          },
          on: {
            change: function change(val) {
              return _vm.onSubmitShop(scope.row.id, val);
            }
          },
          model: {
            value: scope.row.status,
            callback: function callback($$v) {
              _vm.$set(scope.row, "status", $$v);
            },
            expression: "scope.row.status"
          }
        })];
      }
    }])
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      fixed: "right",
      label: "操作",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            type: "primary",
            round: "",
            size: "small"
          },
          on: {
            click: function click($event) {
              return _vm.handleClick(scope.row);
            }
          }
        }, [_vm._v("查看")])];
      }
    }])
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;